import AttributeSelector from "@beeldit/ecommerce/attributes/components/AttributeSelector";
import { Attribute } from "@beeldit/ecommerce/attributes/models/Attribute";

const filterUIConfig = {
  uiScheme: {
    "ui:classNames": "filters-container",
    search: {
      "ui:options": {
        label: false, // Oculta el título del campo
        placeholder: "Buscar...",
      },
    },
    attribute_id: {
      "ui:widget": AttributeSelector,
      "ui:options": {
        label: false,
      },
    },
  },
};
const getFilterUIConfig: any = (type: string) => {
  return filterUIConfig;
};
export default getFilterUIConfig;
